import Swiper, { Thumbs, EffectFade } from 'swiper/core';

Swiper.use([Thumbs, EffectFade]);

function sliderGallery() {
  const gallerys = document.querySelectorAll('.c-gallery');
  const thumbnails = document.querySelectorAll('.c-galleryNav__item');

  const activeSlide = (index) => {
    thumbnails[index]?.classList.add('swiper-slide-thumb-active');
  };

  const inactiveSlide = (index) => {
    thumbnails.forEach((thumbnail, i) => {
      if (index === i) return;
      thumbnail?.classList.remove('swiper-slide-thumb-active');
    });
  };

  gallerys.forEach((gallery) => {
    const gallerySlider = new Swiper(gallery.querySelector('.c-gallery__slider'), {
      autoHeight: true,
      effect: 'fade',
      slidesPerView: 1,
      speed: 400,
    });

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        gallerySlider.slideTo(index);
        activeSlide(index);
        inactiveSlide(index);
      });
    });
  });
  activeSlide(0);
}

export default function slider() {
  sliderGallery();
}
